import { defineStore } from "pinia";
import { useHistoryStore } from "~/stores/HistoryStore";
import {
  type PLAN_TYPE,
  getPlanTypeList,
  getPlanTypeLabelList,
  PLAN_TYPE_DEFAULT,
  getPlanTypeLabel,
} from "~/consts/contentsConfig";

export const useNavigationStore = defineStore(
  "NavigationStore",
  () => {
    const historyStore = useHistoryStore();

    // 現在見ている講座タイプ
    const planType = ref<PLAN_TYPE>(PLAN_TYPE_DEFAULT);

    // 講座タイプのlabel
    const planTypeLabel = computed(() => {
      return getPlanTypeLabel(planType.value);
    });

    // 初期化
    const reset = () => {
      planType.value = PLAN_TYPE_DEFAULT;
    };

    // 講座タイプをセット
    const setPlanType = (type: PLAN_TYPE | undefined) => {
      if (type) {
        planType.value = type;
      }
    };

    // labelから講座タイプをセット
    const setPlanTypeByLabel = (label: string) => {
      const labelList = getPlanTypeLabelList();
      const typeList = getPlanTypeList();
      const index = labelList.indexOf(label);
      if (index !== -1) {
        planType.value = typeList[index] as PLAN_TYPE;
      }
    };

    // routeから講座タイプをセット
    const setPlanTypeByQuery = () => {
      const route = useRoute();
      if (!route.query.planType) {
        return;
      }
      // 大文字にする
      const pType = (route.query.planType as string).toUpperCase();
      const typeList = getPlanTypeList();
      if (typeList.includes(pType as PLAN_TYPE)) {
        planType.value = pType as PLAN_TYPE;
      }
    };

    // 講座タイプによってrouteのqueryを変更
    const changeQueryByPlanType = () => {
      const route = useRoute();
      const query = { ...route.query };
      // デフォルトの場合はqueryを削除
      if (planType.value === PLAN_TYPE_DEFAULT) {
        delete query.planType;
      } else {
        query.planType = planType.value.toLowerCase();
      }
      historyStore.to({ query }, { replace: true });
    };

    return {
      planType,
      planTypeLabel,
      reset,
      setPlanType,
      setPlanTypeByLabel,
      setPlanTypeByQuery,
      changeQueryByPlanType,
    };
  },
  {
    persist: {
      storage: persistedState.localStorage,
    },
  },
);
